import * as THREE from "three"
import React, { useRef } from "react"
import { useFrame } from "@react-three/fiber"

const Dust = ({ active }) => {
    const firefliesGeometry = new THREE.BufferGeometry()
    const firefliesCount = 100
    const positionArray = new Float32Array(firefliesCount * 3)
    const scaleArray = new Float32Array(firefliesCount)

    const dustShaderRef = useRef()
    useFrame((state, delta) => {
        dustShaderRef.current.uTime += delta
    })

    for (let i = 0; i < firefliesCount; i++) {
        positionArray[i * 3 + 0] = (Math.random() - 0.5) * 11
        positionArray[i * 3 + 1] = Math.random() * 5
        positionArray[i * 3 + 2] = (Math.random() - 0.5) * 14 + 4

        scaleArray[i] = Math.random()
    }

    firefliesGeometry.setAttribute("position", new THREE.BufferAttribute(positionArray, 3))
    firefliesGeometry.setAttribute("aScale", new THREE.BufferAttribute(scaleArray, 1))

    return (
        <group>
            <points geometry={firefliesGeometry}>
                <dustShaderMaterial
                    ref={dustShaderRef}
                    transparent={true}
                    blending={THREE.AdditiveBlending}
                    depthWrite={false}
                    uColor={active ? "#9bd8ff" : "#7E706D"}
                />
            </points>
        </group>
    )
}

export default Dust
